<template>
	<div class="car_sells" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="销巴汽车" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
				<img src="../../assets/advDetail/car/top.png" />
				<img src="../../assets/advDetail/car/middle.png" />
				<img src="../../assets/advDetail/car/bottom.png" />
				<p class="phone1"><span>400-0571-671</span>转<span>6</span></p>
				<p class="phone2"><span>0571-8770-8286</span></p>
			</van-col>
		</van-row>
		<p class="footer">
			<a class="btn" href="tel:057187708286" @click="iOStel()">致电垂询</a>
		</p>
	</div>
</template>
<script>
export default {
  data() {
    return {
    	isApp: true,
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
	},
	iOStel() {
		let ua = navigator.userAgent.toLowerCase();
		if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
	        this.phone();
	    }
	},
	phone() {
		this.tel = '057187708286';
		this.params(this.tel, this.tel, 'phone');
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  }
};
</script>
<style lang="less">
.car_sells {
	background: #f2f2f2;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.content {
		background: #18171F;
		padding-bottom: 96px;
		img {
			width: 100%;
			display: block;
		}
		p {
			// height: 21px;
			text-align: center;
			background: linear-gradient(#FFD12D, #FFA514);
			-webkit-background-clip: text;
			color: transparent;
			span {
				height: 20px;
				line-height: 20px;
				font-size: 20px;
				border-bottom: solid 1px #FFA514;
			}
		}
		.phone1 {
			margin-top: 14px;
		}
		.phone2 {
			margin-top: 18px;
		}
	}
	.footer {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		background: #18171F;
		padding: 10px 12px 23px;
		box-sizing: border-box;
		.btn {
			width: 100%;
			height: 50px;
			line-height: 50px;
			color: #171820;
			font-size: 18px;
			text-align: center;
			border-radius: 6px;
			display: block;
			background: -webkit-linear-gradient(#FFD12D, #FFA514); /* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(#FFD12D, #FFA514); /* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(#FFD12D, #FFA514); /* Firefox 3.6 - 15 */
			background: linear-gradient(#FFD12D, #FFA514); /* 标准的语法（必须放在最后） */
		}
	}
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}

</style>
